<div id="cover" *ngIf="projectService.loading() || isLoading"></div>

<div class="section-page entryForm">
    <div class="container-fluid">
        <div class="filter-section">
            <div class="filter-card">
                <div class="filter-content">
                    <div class="filter-group form-select-group">
                        <label class="filter-label">Select Form</label>
                        <p-select [options]="commonDataObject.filterData" optionLabel="form_name"
                            [(ngModel)]="commonDataObject.selected_form" (onChange)="onFormChange('UI')" appendTo="body"
                            [resetFilterOnHide]="true" [style]="{ width: '100%' }" placeholder="Please Select Form">
                        </p-select>
                    </div>
                    <ng-container *ngIf="commonDataObject.selected_form?.form_id">
                        <div class="filter-popover-wrapper">
                            <div style="display: flex; flex-direction: row; align-items: center; gap:20px">
                                <button type="button" class="btn-secondary" (click)="toggleFilterPopover($event)"
                                    [class.active]="isFilterOpen">
                                    <i class="pi pi-filter"></i>
                                    <span class="filter-badge" *ngIf="getActiveFilterCount() > 0">
                                        {{ getActiveFilterCount() }}
                                    </span>
                                </button>
                                <div *ngIf="currentFilterOnYears !== ''" style="margin-bottom: 20px;">
                                    <div style="font-size: 13px; font-weight: 500;">
                                        Current Filter On Years :
                                    </div>
                                    <div style="color: red; font-size: 16px; font-weight: 600;">
                                        {{currentFilterOnYears}}
                                    </div>
                                </div>
                            </div>
                            <div class="filter-popover-panel" [class.open]="isFilterOpen">
                                <div class="popover-header">
                                    <span class="popover-title">
                                        <i class="pi pi-filter"></i> Filters
                                    </span>
                                    <button class="popover-close" (click)="closeFilterPopover()">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                                <div class="popover-body">
                                    <div class="popover-fields-grid">
                                        <div *ngFor="let field of commonDataObject.selectedFormFields || []"
                                            class="popover-field-item">
                                            <label class="filter-label">
                                                {{ field?.field_label[0]?.toUpperCase() +
                                                field?.field_label?.slice(1)?.toLowerCase() }}
                                            </label>
                                            <p-multiSelect [options]="field?.field_values" optionLabel="value"
                                                optionValue="value"
                                                [(ngModel)]="commonDataObject.selectedFilters[field.field_id]"
                                                appendTo="body" [resetFilterOnHide]="true"
                                                [placeholder]="'Select ' + field.field_label"
                                                [style]="{ width: '100%', minWidth: '200px' }" [showHeader]="true"
                                                [filter]="true" [virtualScroll]="field.field_values?.length > 100"
                                                [virtualScrollItemSize]="38" panelStyleClass="custom-multiselect-panel"
                                                (onChange)="generatePayload()">
                                            </p-multiSelect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="filter-backdrop" *ngIf="isFilterOpen" (click)="closeFilterPopover()">
                            </div> -->
                        </div>
                    </ng-container>
                    <div style="margin-left: auto;">
                        <div class="popover-footer">
                            <button type="button" class="btn-primary-save" (click)="geToFormSubmission()">
                                <i class="pi pi-pen-to-square"></i>
                                <span>Form Submission</span>
                            </button>
                            <button type="button" class="btn-secondary" (click)="resetPage()">
                                <i class="pi pi-refresh"></i>
                                <span>Reset</span>
                            </button>
                            <button *ngIf="commonDataObject.tableKeys.length" type="button" class="btn-primary-save"
                                (click)="exportExcel()">
                                <i class="pi pi-download"></i>
                                <span>Export Excel</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="reports-section" *ngIf="commonDataObject.tableKeys.length > 0">
            <div class="tabs-container">
                <div class="tab-headers">
                    <div *ngFor="let tableName of commonDataObject.tableKeys || []; let i = index" class="tab-header"
                        [class.active]="activeTabIndex === i" (click)="setActiveTab(i)">
                        <span class="tab-title">{{ getTabTitle(tableName) }}</span>
                    </div>

                    <div *ngFor="let fv of formulaViews; let j = index" class="tab-header"
                        [class.active]="activeTabIndex === commonDataObject.tableKeys.length + j"
                        (click)="setActiveTab(commonDataObject.tableKeys.length + j)">
                        <span class="tab-title">{{ fv.label }}</span>
                    </div>
                </div>

                <div class="tab-contents">
                    <div *ngFor="let tableName of commonDataObject.tableKeys || []; let i = index" class="tab-content"
                        [class.active]="activeTabIndex === i">
                        <div class="report-container">
                            <div class="report-content">
                                <div class="table-section">
                                    <div class="table-wrapper">
                                        <table class="summary-table">
                                            <thead>
                                                <tr>
                                                    <th *ngFor="let col of (commonDataObject.summaryData[tableName]?.[0] | keyvalue)"
                                                        [class.text-end]="isNumber(getRowValue(tableName, 1, col.key)) || getRowValue(tableName, 1, col.key) == '-'">
                                                        {{ col.value }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let row of (commonDataObject.summaryData[tableName] || [])?.slice(1)"
                                                    [class.total-row]="isTotalRow(row) || row?.is_row_label">
                                                    <!-- <td *ngFor="let col of row | keyvalue"
                                                        [class.text-end]="isNumber(col.value) || col.value == '-'"
                                                        [title]="formatValue(col.value)">
                                                        {{ formatValue(col.value) }}
                                                    </td> -->
                                                    <ng-container *ngFor="let col of row | keyvalue">
                                                        <td *ngIf="col.key !== 'is_row_label'"
                                                            [class.text-end]="isNumber(col.value) || col.value == '-'"
                                                            [title]="formatValue(col.value)">
                                                            {{ formatValue(col.value) }}
                                                        </td>
                                                    </ng-container>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="chart-section">
                                    <div class="chart-container">
                                        <ng-container *ngIf="chartData[tableName]?.labels?.length > 0; else noChart">
                                            <p-chart type="doughnut" [data]="chartData[tableName]"
                                                [options]="chartOptions"
                                                [style]="{ 'height': '320px', 'width': '100%' }">
                                            </p-chart>
                                        </ng-container>
                                        <ng-template #noChart>
                                            <div class="no-chart-data">
                                                <i class="pi pi-chart-line"></i>
                                                <p>No chart data available</p>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let fv of formulaViews; let j = index" class="tab-content"
                        [class.active]="activeTabIndex === commonDataObject.tableKeys.length + j">
                        <div class="formula-container">
                            <div class="formula-layout">
                                <div class="formula-left">
                                    <div class="formula-block" *ngFor="let sec of fv.sections; let n = index">
                                        <div class="formula-block-header" [class.plus]="sec.sign === '+'"
                                            [class.minus]="sec.sign === '-'">
                                            {{ sec.name | titlecase }}
                                            <small>({{ sec.sign }})</small>
                                        </div>

                                        <div class="table-wrapper" *ngIf="sec.key; else noSectionTable">
                                            <table class="summary-table">
                                                <thead>
                                                    <tr>
                                                        <th *ngFor="let col of (commonDataObject.summaryData[sec.key]?.[0] | keyvalue)"
                                                            [class.text-end]="isNumber(getRowValue(sec.key, 1, col.key)) || getRowValue(sec.key, 1, col.key) == '-'">
                                                            {{ col.value }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let row of (commonDataObject.summaryData[sec.key] || [])?.slice(1)"
                                                        [class.total-row]="isTotalRow(row)">
                                                        <!-- <td *ngFor="let col of row | keyvalue"
                                                            [class.text-end]="isNumber(col.value) || col.value == '-'"
                                                            [title]="formatValue(col.value)">
                                                            {{ formatValue(col.value) }}
                                                        </td> -->
                                                        <ng-container *ngFor="let col of row | keyvalue">
                                                            <td *ngIf="col.key !== 'is_row_label'"
                                                                [class.text-end]="isNumber(col.value) || col.value == '-'"
                                                                [title]="formatValue(col.value)">
                                                                {{ formatValue(col.value) }}
                                                            </td>
                                                        </ng-container>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <ng-template #noSectionTable>
                                            <div class="formula-missing">No table found for "{{ sec.name }}"</div>
                                        </ng-template>
                                    </div>

                                    <div class="formula-grand" [class.negative]="fv.result < 0">
                                        <span>{{ fv.label }}</span>
                                        <span>{{ formatValue(fv.result) }}</span>
                                    </div>
                                </div>

                                <div class="formula-right">
                                    <div class="formula-chart-card">
                                        <div class="formula-chart-body">
                                            <p-chart type="doughnut" [data]="fv.chart" [options]="formulaChartOptions"
                                                [style]="{ 'height': '320px', 'width': '100%' }">
                                            </p-chart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="empty-state"
            *ngIf="(commonDataObject.tableKeys.length == 0 && commonDataObject.selected_form?.form_id && !projectService.loading() && !isLoading) || (!commonDataObject.selected_form?.form_id && !projectService.loading() && !isLoading)">
            <div class="empty-state-content">
                <i class="pi pi-inbox"></i>
                <p class="empty-title">No Data Available</p>
                <p class="empty-subtitle">Try adjusting your filters or select a different form</p>
            </div>
        </div>
    </div>
</div>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>

<!-- <div id="cover" *ngIf="projectService.loading() || isLoading"></div>

<div class="section-page entryForm">
    <div class="container-fluid">
        <div class="filter-section">
            <div class="filter-card">
                <div class="filter-content">
                    <div class="filter-group form-select-group">
                        <label class="filter-label">Select Form</label>
                        <p-select [options]="commonDataObject.filterData" optionLabel="form_name"
                            [(ngModel)]="commonDataObject.selected_form" (onChange)="onFormChange('UI')" appendTo="body"
                            [resetFilterOnHide]="true" [style]="{ width: '100%' }" placeholder="Please Select Form">
                        </p-select>
                    </div>
                    <ng-container *ngIf="commonDataObject.selected_form?.form_id">
                        <div class="filter-popover-wrapper">
                            <div style="display: flex; flex-direction: row; align-items: center; gap:20px">
                                <button type="button" class="btn-secondary" (click)="toggleFilterPopover($event)"
                                    [class.active]="isFilterOpen">
                                    <i class="pi pi-filter"></i>
                                    <span class="filter-badge" *ngIf="getActiveFilterCount() > 0">
                                        {{ getActiveFilterCount() }}
                                    </span>
                                </button>
                                <div *ngIf="currentFilterOnYears !== ''" style="margin-bottom: 20px;">
                                    <div style="font-size: 13px; font-weight: 500;">
                                        Current Filter On Years :
                                    </div>
                                    <div style="color: red; font-size: 16px; font-weight: 600;">
                                        {{currentFilterOnYears}}
                                    </div>
                                </div>
                            </div>
                            <div class="filter-popover-panel" [class.open]="isFilterOpen">
                                <div class="popover-header">
                                    <span class="popover-title">
                                        <i class="pi pi-filter"></i> Filters
                                    </span>
                                    <button class="popover-close" (click)="closeFilterPopover()">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                                <div class="popover-body">
                                    <div class="popover-fields-grid">
                                        <div *ngFor="let field of commonDataObject.selectedFormFields || []"
                                            class="popover-field-item">
                                            <label class="filter-label">
                                                {{ field?.field_label[0]?.toUpperCase() +
                                                field?.field_label?.slice(1)?.toLowerCase() }}
                                            </label>
                                            <p-multiSelect [options]="field?.field_values" optionLabel="value"
                                                optionValue="value"
                                                [(ngModel)]="commonDataObject.selectedFilters[field.field_id]"
                                                appendTo="body" [resetFilterOnHide]="true"
                                                [placeholder]="'Select ' + field.field_label"
                                                [style]="{ width: '100%', minWidth: '200px' }" [showHeader]="true"
                                                [filter]="true" [virtualScroll]="field.field_values?.length > 100"
                                                [virtualScrollItemSize]="38" panelStyleClass="custom-multiselect-panel"
                                                (onChange)="generatePayload()">
                                            </p-multiSelect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="filter-backdrop" *ngIf="isFilterOpen" (click)="closeFilterPopover()">
                            </div>
                        </div>
                    </ng-container>
                    <div style="margin-left: auto;">
                        <div class="popover-footer">
                            <button type="button" class="btn-primary-save" (click)="geToFormSubmission()">
                                <i class="pi pi-pen-to-square"></i>
                                <span>Form Submission</span>
                            </button>
                            <button type="button" class="btn-secondary" (click)="resetPage()">
                                <i class="pi pi-refresh"></i>
                                <span>Reset</span>
                            </button>
                            <button *ngIf="commonDataObject.tableKeys.length" type="button" class="btn-primary-save"
                                (click)="exportExcel()">
                                <i class="pi pi-download"></i>
                                <span>Export Excel</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="reports-section" *ngIf="commonDataObject.tableKeys.length > 0">
            <div class="tabs-container">
                <div class="tab-headers">
                    <div *ngFor="let tableName of commonDataObject.tableKeys || []; let i = index" class="tab-header"
                        [class.active]="activeTabIndex === i" (click)="setActiveTab(i)">
                        <span class="tab-title">{{ getTabTitle(tableName) }}</span>
                    </div>
                </div>

                <div class="tab-contents">
                    <div *ngFor="let tableName of commonDataObject.tableKeys || []; let i = index" class="tab-content"
                        [class.active]="activeTabIndex === i">
                        <div class="report-container">
                            <div class="report-content">
                                <div class="table-section">
                                    <div class="table-wrapper">
                                        <table class="summary-table">
                                            <thead>
                                                <tr>
                                                    <th *ngFor="let col of (commonDataObject.summaryData[tableName]?.[0] | keyvalue)"
                                                        [class.text-end]="isNumber(getRowValue(tableName, 1, col.key)) || getRowValue(tableName, 1, col.key) == '-'">
                                                        {{ col.value }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let row of (commonDataObject.summaryData[tableName] || [])?.slice(1)"
                                                    [class.total-row]="isTotalRow(row)">
                                                    <td *ngFor="let col of row | keyvalue"
                                                        [class.text-end]="isNumber(col.value) || col.value == '-'"
                                                        [title]="formatValue(col.value)">
                                                        {{ formatValue(col.value) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="chart-section">
                                    <div class="chart-container">
                                        <ng-container *ngIf="chartData[tableName]?.labels?.length > 0; else noChart">
                                            <p-chart type="doughnut" [data]="chartData[tableName]"
                                                [options]="chartOptions"
                                                [style]="{ 'height': '320px', 'width': '100%' }">
                                            </p-chart>
                                        </ng-container>
                                        <ng-template #noChart>
                                            <div class="no-chart-data">
                                                <i class="pi pi-chart-line"></i>
                                                <p>No chart data available</p>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="formula-section" *ngIf="formulaOptions.length > 0 && commonDataObject.tableKeys.length > 0">
            <div class="formula-select">
                <label class="filter-label">Final Report</label>
                <p-select [options]="formulaOptions" optionLabel="label" optionValue="value"
                    [(ngModel)]="selectedFormula" (onChange)="selectedFormula = $event.value; buildFormulaView()"
                    appendTo="body" placeholder="Select final report" [style]="{ minWidth: '340px' }">
                </p-select>
            </div>

            <ng-container *ngIf="formulaView as fv">
                <div class="formula-title">{{ fv.label }}</div>

                <div class="formula-block" *ngFor="let sec of fv.sections; let n = index">
                    <div class="formula-block-header" [class.plus]="sec.sign === '+'" [class.minus]="sec.sign === '-'">
                        {{ n + 1 }} {{ sec.name | titlecase }}
                        <small>({{ sec.sign }})</small>
                    </div>

                    <div class="table-wrapper" *ngIf="sec.key; else noSectionTable">
                        <table class="summary-table">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of (commonDataObject.summaryData[sec.key]?.[0] | keyvalue)"
                                        [class.text-end]="isNumber(getRowValue(sec.key, 1, col.key)) || getRowValue(sec.key, 1, col.key) == '-'">
                                        {{ col.value }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of (commonDataObject.summaryData[sec.key] || [])?.slice(1)"
                                    [class.total-row]="isTotalRow(row)">
                                    <td *ngFor="let col of row | keyvalue"
                                        [class.text-end]="isNumber(col.value) || col.value == '-'">
                                        {{ formatValue(col.value) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ng-template #noSectionTable>
                        <div class="formula-missing">No table found for "{{ sec.name }}"</div>
                    </ng-template>
                </div>

                <div class="formula-grand" [class.negative]="fv.result < 0">
                    <span>{{ fv.label }}</span>
                    <span>{{ formatValue(fv.result) }}</span>
                </div>
            </ng-container>
        </div>
        <div class="empty-state" *ngIf="!commonDataObject.tableKeys.length && commonDataObject.selected_form?.form_id">
            <div class="empty-state-content">
                <i class="pi pi-inbox"></i>
                <p class="empty-title">No Data Available</p>
                <p class="empty-subtitle">Try adjusting your filters or select a different form</p>
            </div>
        </div>
    </div>
</div>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div> -->